import { useContext } from "react";
import { TableStateContext } from "./TableContextProvider";
import { sortTableData } from "../../components/table/utils/TableUtils";

const useTableData = () => {
  const [tableState, setTableState] = useContext(TableStateContext);

  const initializeTableState = (data, rowIdKey, defaultSortKey, defaultSortType, defaultSortDirection, expandAll, selectAll) => {
    if (Array.isArray(data) && data.length > 0 && rowIdKey) {
      const unsortedData = JSON.parse(JSON.stringify(data));
      const sortedData = sortTableData(data, defaultSortKey, defaultSortType, defaultSortDirection);
      const expandedIds = expandAll ? unsortedData.map((item) => item[rowIdKey]) : [];
      const selectedIds = selectAll ? unsortedData.map((item) => item[rowIdKey]) : [];

      setTableState({
        ...tableState,
        isInitialized: true,
        unsortedData,
        sortedData,
        rowIdKey,
        sortKey: defaultSortKey || '',
        sortType: defaultSortType || '',
        sortDirection: defaultSortDirection || '',
        expandedIds,
        selectedIds
      });
    }
  };

  const onUpdateTableData = (data) => {
    const unsortedData = JSON.parse(JSON.stringify(data));
    const expandedIds = tableState.expandedIds.filter((id) => unsortedData.some((item) => item[tableState.rowIdKey] === id));
    const selectedIds = tableState.selectedIds.filter((id) => unsortedData.some((item) => item[tableState.rowIdKey] === id));

    if (tableState.sortKey && tableState.sortType && tableState.sortDirection) {
      const sortedData = sortTableData(data, tableState.sortKey, tableState.sortType, tableState.sortDirection);

      setTableState({
        ...tableState,
        unsortedData,
        sortedData,
        expandedIds,
        selectedIds
      });
    } else {
      setTableState({
        ...tableState,
        unsortedData,
        sortedData: JSON.parse(JSON.stringify(data)),
        expandedIds,
        selectedIds
      });
    }
  };

  const onUpdateExpandedIds = (newExpandedIds) => {
    setTableState({
      ...tableState,
      expandedIds: newExpandedIds
    });
  };

  const onUpdateSelectedIds = (newSelectedIds) => {
    setTableState({
      ...tableState,
      selectedIds: newSelectedIds
    });
  };

  const onUpdateTableSort = (sortKey, sortType, sortDirection) => {
    if (sortKey && sortType && sortDirection) {
      const sortedData = sortTableData(tableState.sortedData, sortKey, sortType, sortDirection);

      setTableState({
        ...tableState,
        sortedData,
        sortKey: sortKey || '',
        sortType: sortType || '',
        sortDirection: sortDirection || ''
      });
    } else {
      setTableState({
        ...tableState,
        sortedData: JSON.parse(JSON.stringify(tableState.unsortedData)),
        sortKey: '',
        sortType: '',
        sortDirection: ''
      });
    }
  }

  return {
    tableState,
    setTableState,
    initializeTableState,
    onUpdateTableData,
    onUpdateExpandedIds,
    onUpdateSelectedIds,
    onUpdateTableSort
  };
};

export default useTableData;